import CollapsibleRowTable from "./CollapsibleRowTable.tsx";

export default CollapsibleRowTable;
